<template>
  <div class="h-screen overflow-hidden flex flex-col justify-between bg-white border-solid border-l border-0 border-gray-border">
    <div>
      <div class="border-solid border-b border-0 border-gray-border px-8 pb-8">
        <h3 class="font-semibold mt-8 truncate">
          <span class="text-gray-dark">{{ botDisplayName }}</span>
          <span class="text-gray ml-1">/</span>
          <span class="text-black ml-1">Add market</span>
        </h3>
      </div>

      <settings-bot-market-form v-model="marketForm"
                                :multi-bots="multiBots"
                                :exclude-multi-bot-id="bot.multi_bot_id"
                                content-class="px-8"
      />
    </div>

    <div class="grid grid-cols-2 gap-4 mb-6 px-8">
      <busy-button id="addMarketCreateButton"
                   variant="primary"
                   class="col-span-1"
                   :is-loading="isLoading"
                   :is-disabled="!isMarketFormValid || isLoading"
                   @click="submit"
      >
        Create
      </busy-button>
      <base-button variant="bordered"
                   class="col-span-1 justify-center"
                   @click="$emit('cancel')"
      >
        Cancel
      </base-button>
    </div>
  </div>
</template>

<script>
import BusyButton from '@/components/common/BusyButton'
import BaseButton from '@/components/base-components/BaseButton.vue'
import SettingsBotMarketForm from '@/components/settings/bots/SettingsBotMarketForm.vue'
import {
  createDefaultMarketForm,
  getAvailableMarketOptions,
  isMarketFormValid
} from '@/utils/market.utils'

export default {
  name: 'SettingsBotAddMarketEditor',

  components: {
    BusyButton,
    BaseButton,
    SettingsBotMarketForm
  },

  props: {
    bot: {
      type: Object,
      required: true
    },
    multiBots: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  emits: ['cancel', 'create'],

  data() {
    return {
      marketForm: createDefaultMarketForm({
        language: this.bot.language,
        timezone: this.bot.timezone
      })
    }
  },

  computed: {
    botDisplayName() {
      return this.bot.multi_bot_name || this.bot.name
    },
    isMarketFormValid() {
      const hasExistingMarketOptions = getAvailableMarketOptions(this.multiBots, this.bot.multi_bot_id).length > 0
      return isMarketFormValid(this.marketForm, hasExistingMarketOptions)
    }
  },

  methods: {
    submit() {
      this.$emit('create', { ...this.marketForm })
    }
  }
}
</script>
